import { FC } from 'react';
import {
    EditProps,
    FormWithRedirect,
    TextInput,
    useTranslate,
    AutocompleteInput,
    SelectInput,
    required,
    ReferenceInput,
    // DateInput,
    // FormDataConsumer,
    NumberInput,
    // DeleteButton,
    SaveButton,
    Toolbar,
} from 'react-admin';
import {
    makeStyles,
    createStyles,
    Theme,
    Typography,
    Box,
    // Toolbar,
    Grid,
} from '@material-ui/core';
import getCountries from '../utils/countries'
import { PercentFormatInput, CurrencyFormatInput, dateLocales, defaultDateOptions } from '../utils/formatters';
import _ from "lodash";
import { getOffersStatuses } from './OffersTypes';
import { JsonInput } from "react-admin-json-view";
import { DateTimeInput } from '../components/DatePickers';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }),
);

const OffersEdit: FC<EditProps> = props => {
    const classes = useStyles()
    const translate = useTranslate()

    const resource = props.resource

    const countries = getCountries()
    const offersStatuses = getOffersStatuses()

    const listCurrencies = Object.keys(_.groupBy(countries, c => c.code)).map(k => ({ name: k, id: k }))

    return <FormWithRedirect
        {...props}
        render={formProps => (
            // here starts the custom form layout
            <Box>
                <Typography variant="h6">{translate("resources.common.fieldGroups.basicInfo")}</Typography>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12}>
                        <AutocompleteInput
                            source="status"
                            choices={offersStatuses}
                            resettable
                            fullWidth
                        />
                        {/* <Grid item xs={12}>
                            <Button
                                source="status"
                                choices={offersStatuses}
                                resettable
                                fullWidth
                            />
                        </Grid> */}
                    </Grid>
                    <Grid item xs={12} sm={3} lg={4}>
                        <TextInput
                            source="amount"
                            resource={resource}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={2}>
                        <SelectInput source="currency"
                            defaultValue="MXN"
                            choices={listCurrencies}
                            resource={resource}
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="total_repayment_amount"
                            resource={resource}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <TextInput
                            source="fixed_fee_rate"
                            resource={resource}
                            InputProps={{
                                inputComponent: PercentFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="fixed_fee"
                            resource={resource}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <TextInput
                            source="tax_rate"
                            resource={resource}
                            InputProps={{
                                inputComponent: PercentFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="tax"
                            resource={resource}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <TextInput
                            source="repayment_rate"
                            resource={resource}
                            InputProps={{
                                inputComponent: PercentFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <NumberInput
                            source="expected_tenor"
                            resource={resource}
                            InputProps={{
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <NumberInput
                            source="term"
                            resource={resource}
                            InputProps={{
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <DateTimeInput
                            source="valid_from"
                            locale={dateLocales}
                            providerOptions={{ locale: dateLocales, }}
                            options={defaultDateOptions}
                            InputProps={{
                                readOnly: true,
                            }}
                            validate={[required()]}
                            show
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6} >
                        <NumberInput
                            source="active_days"
                            resource={resource}
                            InputProps={{
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="six_months_median_sales"
                            resource={resource}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                                readOnly: true,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <ReferenceInput
                            source="merchant_id"
                            reference="merchants"
                            sort={{ field: 'id', order: 'ASC' }}
                            perPage={10}
                            resource={resource}
                            filterToQuery={name => ({ name })}
                            validate={[required()]}
                        >
                            {/* <AutocompleteInput
                                optionText="id"
                                fullWidth
                                InputProps={{
                                    readOnly: true,
                                }}
                            /> */}
                            <TextInput
                                source="id"
                                optionText="id"
                                fullWidth
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </ReferenceInput>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <JsonInput
                            source="data"
                            jsonString={false} // Set to true if the value is a string, default: false
                            reactJsonOptions={{
                                // Props passed to react-json-view
                                name: null,
                                collapsed: true,
                                enableClipboard: false,
                                displayDataTypes: false,
                            }}
                        />
                    </Grid>
                </Grid>
                <Toolbar>
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <SaveButton
                            saving={formProps.saving}
                            transform={data => { //TODO: change when other properties
                                return { status: data.status }
                            }}
                            handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                        />
                        {/* <DeleteButton record={formProps.record} /> */}
                    </Box>
                </Toolbar>
            </Box>
        )}
    />
}

export default OffersEdit;
